<template>
  <div>
    <v-toolbar
        color="primary"
        class="navigation"
        dark
        prominent
    >
      <div class="pa-0 mx-0 d-flex flex-column" style="height: 100%">
        <div class="d-flex flex-row align-center">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
          <h2 style="font-family: Montserrat, sans-serif">GUIOMENTOR</h2>
        </div>
        <v-list-item-group active-class="active-item"  class="mt-auto d-flex flex-row pa-0 ma-0">
          <v-list-item class="mb-0 pb-0" link to="/home" :class="$route.path.indexOf('blogs') !== -1 ? 'active-item' : ''">
            <v-list-item-title> Blogs</v-list-item-title>
          </v-list-item>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                  v-bind="attrs" v-on="on"
                  class="mb-0 pb-0"
                  :class="$route.path.indexOf('learning') !== -1 ? 'active-item' : ''"
              >
                <v-list-item-title> Learning</v-list-item-title>
              </v-list-item>
            </template>
            <v-list>
              <v-list-item v-for="(item,index) in learningLinks" :key="index" link :to="item.link">
                <v-list-item-title >{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-group>
      </div>
      <v-spacer/>
        <v-menu v-if="isAuthenticated" bottom min-width="200px" offset-y rounded>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon x-large elevation="3" class="mr-1">
              <Avatar :canRouteToProfile="false" :user="user" size="45"/>
            </v-btn>
          </template>
          <v-card>
            <v-list-item-content class="justify-center">
              <div class="mx-auto text-center">
                <v-btn
                    elevation="0"
                    depressed rounded text
                    v-if="isMentor && user.uuid"
                    class="text-decoration-none text-body-2 text-no-wrap"
                    :to="`/mentors/${user.uuid}`"
                >
                  My Public Profile
                </v-btn>
                <v-divider class="my-3" v-if="isMentor && user.uuid"></v-divider>
                <v-btn
                    elevation="0" depressed rounded text to="/profile/"
                    class="text-decoration-none text-body-2 text-no-wrap"
                >
                  Edit Account
                </v-btn>
                <v-divider class="my-3"></v-divider>
                <v-btn
                    depressed rounded text
                    @click="handleLogout()"
                    class="text-decoration-none text-body-2 text-no-wrap"
                >
                  Logout
                </v-btn>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
    </v-toolbar>
    <v-navigation-drawer
        v-if="$vuetify.breakpoint.xs"
        v-model="drawer"
        color="primary"
        class="px-2 pb-15"
        app
        temporary
    >
      <div style="height: 15vh; width: auto;" class="d-flex flex-column justify-center align-start pl-4">
        <router-link to="/">
          <img :src="logo" alt="company logo" class="logo" />
        </router-link>
      </div>
      <v-text-field
          v-model.lazy="searchString"
          background-color="#f5f6f8"
          class="shrink mx-2"
          dense
          flat
          hide-details
          rounded
          @keydown.enter="search(searchString)"
          @input="debounceSearch(searchString)"
          solo
          clearable
      >
        <template v-if="!searchString" v-slot:label>
          <v-icon class="mr-2">mdi-magnify</v-icon>
          search a blog
        </template>
      </v-text-field>
      <side-menu />
      <template v-slot:append>
        <div v-if="!isAuthenticated" class="mb-2">
          <v-btn
              :to="`/login?from=${currentRoute}`"
              elevation="1"
              class="mb-2"
              color="white"
              style="color: #0033AA; width: 100%"
          >
            Login
          </v-btn>
          <v-btn
              :to="`/signup?from=${currentRoute}`"
              elevation="1"
              color="primary"
              style="width: 100%"
          >
            Signup
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <log-out-dialog
        :reveal="showLogOutDialog"
        @cancel="showLogOutDialog = false"
        @logOutSuccess="showLogOutDialog = false"
    />
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu";
import logo from "@/assets/logo-white.svg";
import Avatar from "@/components/Avatar";
import {mapGetters, mapMutations} from "vuex";
import LogOutDialog from "@/components/LogOutDialog";

export default {
  name: "MobileNavBar",
  components: {LogOutDialog, Avatar, SideMenu},
  data: () => ({
    logo,
    drawer: false,
    searchString: "",
    showLogOutDialog: false,
    learningLinks: [
      { title: 'Tutors',link:"/tutors" },
      { title: 'Question Material/Past papers',link:"/questions" },
    ]
  }),
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      logOut: "auth/SET_AUTH_LOGOUT",
      setProfile: "auth/SET_USER_PROFILE"
    }),
    async handleLogout() {
      this.showLogOutDialog = true;
    },
    debounceSearch(searchString){
      clearTimeout(this._timerId)
      this._timerId = setTimeout(()=> {this.search(searchString)},1100)
    },
    search(searchString){
      if(searchString.trim()?.length){
        this.$router.push({path: `/blogs/search?q=${searchString.trim()}`}).catch(()=>{})
      } else {
        this.$router.push({path: `/blogs/search`}).catch(()=>{})
      }
    },
  },
  mounted() {
    if(process.env.VUE_APP_ENVIRONMENT !== 'production') {
      this.learningLinks = [...this.learningLinks,
        { title: 'Learning materials',link:"/learning" }]
    }
    this.searchString = this.$route?.query?.q || ""
    if(this.user?.profile?.country) {
      this.selectedCountry = this.user?.profile?.country;
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    isMentor() {
      return this.user.account_types?.filter((item) => item.name === "MENTOR").length;
    },
    isLoginPage() {
      return this.$route.path.indexOf("login") !== -1;
    },
    isSignInPage() {
      return this.$route.path.indexOf("signup") !== -1;
    },
    currentRoute() {
      return this.$router?.currentRoute?.path;
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .v-toolbar__content, .v-toolbar__extension {
  padding-bottom: 0 !important;
  padding-left: 0 !important;
  padding-top: 1em !important;
}

.navigation {
  width: 100%;
  position: fixed;
  padding-bottom: 0;
  z-index: 2;

  .active-item {
    border-bottom: 0.2em solid white;
    background-color: #0035B0 !important;
  }

  .theme--light.v-list-item--active:hover::before,
  .theme--light.v-list-item--active::before {
    background-color: #0035B0 !important;
  }

  .theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
    opacity: 0 !important;
  }
}

.logo {
  width: 80px;
  height: 80px;
}
</style>
